(() => {
  const drawer = document.getElementById('ShopheltenSideDrawer');
  if (!drawer) return;

  const titleEl = drawer.querySelector('[data-side-drawer-title]');
  const bodyEl = drawer.querySelector('[data-side-drawer-body]');
  const footerEl = drawer.querySelector('[data-side-drawer-footer]');
  const closeBtn = drawer.querySelector('[data-side-drawer-close]');
  const sizeSheet = drawer.querySelector('[data-size-sheet]');
  const sheetList = drawer.querySelector('[data-size-sheet-list]');
  const sheetAddBtn = drawer.querySelector('[data-size-sheet-add]');
  const sheetProductLink = drawer.querySelector('[data-size-sheet-product]');
  let sheetVariant = null;
  let sheetImageSrc = '';
  let sheetSourceAddButton = null;
  let openerEl = null;
  let lastCartAddButton = null;
  let lastCartAddImageSrc = '';
  let notificationToken = 0;

  const themeObject = () => window.theme || {};
  const cartUpsellStrings = () => themeObject().strings?.cartUpsell || {};
  const str = (key, fallback) => cartUpsellStrings()[key] || fallback;
  const route = (key, fallback) => themeObject().routes?.[key] || fallback;

  function formatMoney(cents) {
    const format = themeObject().settings?.moneyWithCurrencyFormat || '{{ amount }}';
    const value = Number(cents || 0) / 100;
    const formatNumber = (precision, thousands, decimal) => {
      const fixed = value.toFixed(precision);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
    };

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, formatNumber(0, '.', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatNumber(2, '.', ','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatNumber(2, '\'', '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, formatNumber(0, ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, formatNumber(2, ',', '.'));
  }

  function cartJsonUrl() {
    return `${route('cart', '/cart')}.js`;
  }

  let cartHandles = {};
  function setCartHandles(cart) {
    cartHandles = {};
    (cart?.items || []).forEach((item) => {
      if (item.handle) cartHandles[item.handle] = true;
    });
  }

  function refreshCartHandles() {
    return fetch(cartJsonUrl(), { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => response.json())
      .then(setCartHandles)
      .catch(() => {});
  }

  function handleFromCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    const match = (link?.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function excludeInCart(node) {
    if (!node) return null;
    node.querySelectorAll('.card').forEach((card) => {
      const handle = handleFromCard(card);
      if (handle && cartHandles[handle]) card.remove();
    });
    return node.querySelector('.card') ? node : null;
  }

  function fetchUpsellList(productId, intent) {
    if (!productId) return Promise.resolve(null);
    return fetch(productRecommendationsUrl(productId, intent), { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((html) => excludeInCart(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-upsell-list-recs]')));
  }

  function fetchLinkedCards(handle) {
    if (!handle) return Promise.resolve([]);
    return fetch(productSectionUrl(handle), { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((html) => {
        const list = excludeInCart(
          new DOMParser().parseFromString(html, 'text/html').querySelector('[data-upsell-list-stl]')
        );
        return cardsFromNode(list);
      })
      .catch(() => []);
  }

  function productRecommendationsUrl(productId, intent) {
    const root = window.Shopify?.routes?.root || '/';
    const params = new URLSearchParams({
      section_id: 'cart-upsell',
      intent,
      limit: '8',
      product_id: productId
    });
    return `${root}recommendations/products?${params.toString()}`;
  }

  function productSectionUrl(handle) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}products/${handle}?section_id=cart-upsell`;
  }

  function setTitle(text) {
    titleEl.textContent = text;
  }

  function setFooter(nodes) {
    footerEl.replaceChildren();
    if (nodes && nodes.length) {
      nodes.forEach((node) => footerEl.appendChild(node));
      footerEl.hidden = false;
    } else {
      footerEl.hidden = true;
    }
  }

  function closeSizeSheet() {
    if (!sizeSheet) return;
    sheetImageSrc = '';
    sheetSourceAddButton = null;
    sizeSheet.classList.remove('is-open');
    sizeSheet.setAttribute('aria-hidden', 'true');
  }

  function openDrawer(opener) {
    openerEl = opener || document.activeElement;
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('shophelten-side-drawer-open');
    setTimeout(() => closeBtn?.focus({ preventScroll: true }), 40);
  }

  function waitForImageReady(image, timeout = 1500) {
    if (!image || !image.getAttribute('src') || image.complete) return Promise.resolve();

    return new Promise((resolve) => {
      let done = false;
      let timer = null;
      const finish = () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
        resolve();
      };

      timer = setTimeout(finish, timeout);
      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
    });
  }

  function confirmMainImage(root) {
    return root?.querySelector?.('.shophelten-side-drawer__confirm-img:not(.shophelten-side-drawer__confirm-img--hover)');
  }

  function openDrawerWhenConfirmImageReady(confirm, opener, token) {
    waitForImageReady(confirmMainImage(confirm)).then(() => {
      if (token === notificationToken) openDrawer(opener);
    });
  }

  function closeDrawer() {
    notificationToken += 1;
    closeSizeSheet();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('shophelten-side-drawer-open');
    if (openerEl && typeof openerEl.focus === 'function') {
      setTimeout(() => openerEl.focus({ preventScroll: true }), 120);
    }
  }

  function lineSize(line) {
    const options = line?.options_with_values || [];
    const sizeOption = options.find((option) => {
      const name = (option?.name || '').toLowerCase();
      return name === 'size' || name === 'størrelse' || name === 'storrelse';
    });
    if (sizeOption?.value) return sizeOption.value;
    if (line?.variant_title && line.variant_title !== 'Default Title') return line.variant_title;
    return '';
  }

  function normalizeCartAddResponse(data) {
    if (data?.items?.length) return data.items[0];
    return data;
  }

  function isFeeProductLine(line) {
    const feeVariantId = window.fee_product?.id;
    const lineVariantId = line?.variant_id || line?.id;
    return feeVariantId && Number(lineVariantId) === Number(feeVariantId);
  }

  function cartAddUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function cartAddMethod(input, init) {
    if (init?.method) return init.method.toUpperCase();
    if (typeof Request !== 'undefined' && input instanceof Request && input.method) {
      return input.method.toUpperCase();
    }
    return 'GET';
  }

  function isCartAddRequest(input) {
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(cartAddUrl(input));
  }

  function isCartAddForm(form) {
    return form?.action && isCartAddRequest(form.action);
  }

  function buttonText(button) {
    return [
      button?.textContent,
      button?.value,
      button?.dataset?.addToCartText,
      button?.getAttribute?.('aria-label')
    ].filter(Boolean).join(' ').trim().toLowerCase();
  }

  function hasEnglishCartText(button) {
    return /\badd\s+to\s+(cart|basket)\b/i.test(buttonText(button));
  }

  function looksLikeCartAddButton(button) {
    if (!button || button.closest('[data-stl-add], #ShopheltenSideDrawer')) return false;
    if (button.matches('[name="add"], [data-add-to-cart]')) return true;
    if (isCartAddForm(button.closest('form'))) return true;

    const text = buttonText(button);
    return text.includes('tilføj')
      || text.includes('læg i kurv')
      || text.includes('læg i kurven')
      || text.includes('add to cart')
      || text.includes('add to basket');
  }

  function cartAddButtonFromTarget(target) {
    const button = target?.closest?.('[name="add"], [data-add-to-cart], button, input[type="submit"], a[role="button"]');
    return looksLikeCartAddButton(button) ? button : null;
  }

  function normalizeImageSrc(src) {
    const value = (src || '').trim();
    if (!value) return '';
    if (value.startsWith('//')) return `${window.location.protocol}${value}`;
    return value;
  }

  function currentImageSrc(image) {
    if (!image) return '';
    return normalizeImageSrc(image.currentSrc || image.getAttribute('src') || image.src || '');
  }

  function imageSrcFromCartAddButton(button) {
    const scope = button?.closest?.('product-card, .card--product, .card, [data-product-id], .product-block, .product-item, article, li');
    const image = scope?.querySelector?.('.card__main-image:not([hidden]), .product-card__image img:not([hidden]), .card__media img:not([hidden]), img:not([hidden])');
    return currentImageSrc(image);
  }

  function cacheCartAddButton(button) {
    if (!button || button.shopheltenOriginalAtcHtml) return;
    const visibleText = button.textContent.trim();
    const valueText = 'value' in button ? button.value : '';
    const originalText = visibleText
      || valueText
      || button.dataset?.addToCartText
      || button.getAttribute?.('aria-label')
      || themeObject().strings?.addToCart
      || '';

    button.shopheltenOriginalAtcHtml = button.innerHTML;
    button.shopheltenOriginalAtcText = originalText;

    if (button.dataset && originalText) {
      button.dataset.addToCartText = originalText;
    }

    if ('value' in button) button.shopheltenOriginalAtcValue = button.value;
  }

  function restoreCartAddButtonNow(button) {
    if (!button) return;
    if (!document.documentElement.contains(button)) return;
    if (button.classList.contains('is-added') || button.closest('#ShopheltenSideDrawer')) return;

    button.shopheltenAtcRestoring = true;
    try {
      if (button.shopheltenOriginalAtcHtml) {
        button.innerHTML = button.shopheltenOriginalAtcHtml;
      } else if (button.shopheltenOriginalAtcText) {
        button.textContent = button.shopheltenOriginalAtcText;
      }
      if ('value' in button && button.shopheltenOriginalAtcValue) {
        button.value = button.shopheltenOriginalAtcValue;
      }
      if (button.dataset && button.shopheltenOriginalAtcText) {
        button.dataset.addToCartText = button.shopheltenOriginalAtcText;
      }
    } finally {
      setTimeout(() => {
        button.shopheltenAtcRestoring = false;
      });
    }
  }

  function restoreCartAddButton(button) {
    [0, 40, 120, 260, 500, 900, 1400, 2200].forEach((delay) => {
      setTimeout(() => restoreCartAddButtonNow(button), delay);
    });
  }

  function guardCartAddButton(button) {
    if (!button) return;

    cacheCartAddButton(button);
    if (hasEnglishCartText(button)) restoreCartAddButtonNow(button);

    if (typeof MutationObserver === 'undefined') return;

    if (!button.shopheltenAtcObserver) {
      button.shopheltenAtcObserver = new MutationObserver(() => {
        if (button.shopheltenAtcRestoring) return;
        if (hasEnglishCartText(button)) restoreCartAddButtonNow(button);
      });
      button.shopheltenAtcObserver.observe(button, {
        attributes: true,
        attributeFilter: ['aria-label', 'data-add-to-cart-text', 'value'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    clearTimeout(button.shopheltenAtcGuardTimer);
    button.shopheltenAtcGuardTimer = setTimeout(() => {
      button.shopheltenAtcObserver?.disconnect();
      button.shopheltenAtcObserver = null;
    }, 3000);
  }

  function rememberCartAddButton(button) {
    if (!button) return;
    guardCartAddButton(button);
    lastCartAddButton = button;
    lastCartAddImageSrc = imageSrcFromCartAddButton(button);
  }

  function clearCartAddSuppression() {
    const api = window.ShopHeltenCartUpsell;
    if (api) api.suppressNextCartAdd = false;
    window.suppressCartNotification = false;
  }

  function handleCartAddResponse(data) {
    const api = window.ShopHeltenCartUpsell;
    const suppressed = api?.suppressNextCartAdd || window.suppressCartNotification === true;
    const line = normalizeCartAddResponse(data);
    const opener = lastCartAddButton;
    const immediateImageSrc = lastCartAddImageSrc;

    clearCartAddSuppression();
    lastCartAddImageSrc = '';
    restoreCartAddButton(opener);
    refreshCartUi();

    if (suppressed || !line || isFeeProductLine(line)) return;
    openNotification(line, opener, immediateImageSrc);
  }

  function installCartAddHook() {
    if (window.ShopHeltenCartAddHookReady) return;
    window.ShopHeltenCartAddHookReady = true;

    if (typeof window.fetch === 'function') {
      const nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        const shouldTrack = cartAddMethod(input, init) === 'POST' && isCartAddRequest(input);
        const result = nativeFetch.apply(this, arguments);

        if (shouldTrack) {
          result
            .then((response) => {
              if (!response?.ok) {
                clearCartAddSuppression();
                return null;
              }
              return response.clone().json();
            })
            .then((data) => {
              if (data) handleCartAddResponse(data);
            })
            .catch((error) => {
              clearCartAddSuppression();
              console.error(error);
            });
        }

        return result;
      };
    }

    if (typeof XMLHttpRequest === 'undefined') return;

    const nativeOpen = XMLHttpRequest.prototype.open;
    const nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.shopheltenCartAddTracked = method?.toUpperCase() === 'POST' && isCartAddRequest(url);
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.shopheltenCartAddTracked) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) {
            clearCartAddSuppression();
            return;
          }
          try {
            handleCartAddResponse(JSON.parse(this.responseText));
          } catch (error) {
            clearCartAddSuppression();
            console.error(error);
          }
        });
      }

      return nativeSend.apply(this, arguments);
    };
  }

  function refreshCartIcon() {
    return fetch('?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((data) => {
        const html = data && data['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#cart-icon-bubble');
        bubble.innerHTML = inner ? inner.innerHTML : html;
      })
      .catch(() => {});
  }

  function refreshCartUi() {
    refreshCartIcon();

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      cartDrawer.refresh(true);
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    }

    const cartItems = document.querySelector('main cart-items');
    if (window.location.pathname === route('cart', '/cart') && cartItems && typeof cartItems.refresh === 'function') {
      cartItems.refresh();
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function addItems(items) {
    if (window.ShopHeltenCartUpsell) {
      window.ShopHeltenCartUpsell.suppressNextCartAdd = true;
    }
    window.suppressCartNotification = true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    }).then((response) => {
      if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
      return response.json();
    });
  }

  function variantIdFor(row) {
    const sizes = row.querySelector('[data-stl-sizes]');
    if (!sizes) return null;
    if (sizes.dataset.singleVariant) return sizes.dataset.singleVariant;
    return sizes.querySelector('[data-stl-size].is-selected')?.dataset.variantId || null;
  }

  function markAdded(button) {
    if (!button) return;
    button.classList.remove('is-loading', 'is-success');
    button.classList.add('is-added');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    const label = `✓ ${button.dataset.addedLabel || str('added', 'Tilføjet')}`;
    const text = button.querySelector('.stl-product__add-text');
    if (text) text.textContent = label;
    else button.textContent = label;
    button.setAttribute('aria-label', label);
  }

  function enhanceSizeRows(root) {
    root.querySelectorAll('[data-stl-sizes]').forEach((sizes) => {
      if (sizes.dataset.singleVariant) return;
      sizes.addEventListener('wheel', (event) => {
        if (sizes.scrollWidth <= sizes.clientWidth) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        sizes.scrollLeft += event.deltaY;
        event.preventDefault();
      }, { passive: false });
    });
  }

  function removeBrokenHoverImage(image) {
    const imageWrap = image.closest('.stl-product__image, .shophelten-side-drawer__confirm-media');
    image.remove();
    imageWrap?.classList.remove('has-hover-image');
  }

  function cleanHoverImages(root = document) {
    root.querySelectorAll('.stl-product__image-hover, .shophelten-side-drawer__confirm-img--hover').forEach((image) => {
      if (!image.getAttribute('src')) {
        removeBrokenHoverImage(image);
        return;
      }

      if (image.complete && image.naturalWidth === 0) {
        removeBrokenHoverImage(image);
      }
    });
  }

  function markConfirmImageLoaded(media) {
    media.classList.remove('is-hidden', 'has-image-error');
    media.classList.add('is-loaded');
  }

  function setConfirmImage(media, image, src) {
    const nextSrc = normalizeImageSrc(src);
    if (!media || !image) return;

    if (!nextSrc) {
      if (!image.getAttribute('src')) media.classList.add('is-hidden');
      return;
    }

    const currentSrc = normalizeImageSrc(image.getAttribute('src'));
    if (currentSrc) {
      if (currentSrc === nextSrc && image.complete && image.naturalWidth > 0) {
        markConfirmImageLoaded(media);
      }
      return;
    }

    media.classList.remove('has-image-error', 'is-hidden', 'is-loaded');
    image.onload = () => markConfirmImageLoaded(media);
    image.onerror = () => {
      media.classList.add('is-hidden', 'has-image-error');
      media.classList.remove('is-loaded');
    };
    image.src = nextSrc;

    if (image.complete && image.naturalWidth > 0) markConfirmImageLoaded(media);
  }

  function setConfirmHoverImage(media, hoverUrl, mainSrc) {
    if (!media) return;

    media.querySelectorAll('.shophelten-side-drawer__confirm-img--hover').forEach((image) => image.remove());
    media.classList.remove('has-hover-image');

    const hoverSrc = normalizeImageSrc(hoverUrl);
    if (!hoverSrc || hoverSrc === normalizeImageSrc(mainSrc)) return;

    media.classList.add('has-hover-image');
    const showHover = () => {
      if (!media.isConnected || media.querySelector('.shophelten-side-drawer__confirm-img--hover')) return;

      const hover = document.createElement('img');
      hover.className = 'shophelten-side-drawer__confirm-img shophelten-side-drawer__confirm-img--hover';
      hover.alt = '';
      hover.setAttribute('aria-hidden', 'true');
      hover.decoding = 'async';
      hover.onload = () => hover.classList.add('is-ready');
      hover.src = hoverSrc;
      media.appendChild(hover);
      if (hover.complete && hover.naturalWidth > 0) hover.classList.add('is-ready');
    };

    media.addEventListener('pointerenter', showHover, { once: true });
    media.addEventListener('focusin', showHover, { once: true });
  }

  function isSingleVariant(card) {
    const sizes = card.querySelector('[data-stl-sizes]');
    return !!sizes?.dataset.singleVariant;
  }

  function openSizeSheet(card) {
    if (!sizeSheet) return;
    const sizesEl = card.querySelector('[data-stl-sizes]');
    const titleLink = card.querySelector('.stl-product__title');
    sheetProductLink.href = titleLink ? titleLink.getAttribute('href') : '#';
    sheetVariant = null;
    sheetSourceAddButton = card.querySelector('[data-stl-add]');
    sheetImageSrc = currentImageSrc(card.querySelector('.stl-product__image-main, .stl-product__image img, img'));
    sheetAddBtn.disabled = true;
    sheetList.replaceChildren();

    sizesEl?.querySelectorAll('[data-stl-size]').forEach((button) => {
      const row = document.createElement('button');
      row.type = 'button';
      row.className = 'size-sheet__size';
      row.setAttribute('data-size-sheet-size', '');
      row.dataset.variantId = button.dataset.variantId;

      const label = document.createElement('span');
      label.className = 'size-sheet__size-label';
      label.textContent = button.textContent.trim();
      row.appendChild(label);

      if (button.disabled) {
        row.disabled = true;
        row.classList.add('size-sheet__size--unavailable');
      }

      sheetList.appendChild(row);
    });

    const firstAvailable = sheetList.querySelector('.size-sheet__size:not(.size-sheet__size--unavailable)');
    if (firstAvailable) {
      firstAvailable.classList.add('is-selected');
      sheetVariant = firstAvailable.dataset.variantId;
      sheetAddBtn.disabled = false;
    }

    sizeSheet.classList.add('is-open');
    sizeSheet.setAttribute('aria-hidden', 'false');
  }

  function addOne(addButton) {
    const row = addButton.closest('[data-stl-product]');
    if (!row) return;
    const variantId = variantIdFor(row);
    if (!variantId) {
      row.querySelector('[data-stl-sizes]')?.classList.add('is-missing-size');
      return;
    }

    addButton.classList.add('is-loading');
    addItems([{ id: variantId, quantity: 1 }])
      .then(() => {
        addButton.classList.remove('is-loading');
        markAdded(addButton);
        refreshCartUi();
      })
      .catch((error) => {
        addButton.classList.remove('is-loading');
        console.error(error);
      });
  }

  function addFromSheet() {
    if (!sheetVariant) return;
    const sourceButton = sheetSourceAddButton;
    sheetAddBtn.disabled = true;
    addItems([{ id: sheetVariant, quantity: 1 }])
      .then(() => {
        closeSizeSheet();
        if (sourceButton) markAdded(sourceButton);
        refreshCartUi();
      })
      .catch((error) => {
        sheetAddBtn.disabled = false;
        console.error(error);
      });
  }

  function notificationActions() {
    const row = document.createElement('div');
    row.className = 'shophelten-side-drawer__actions';

    const go = document.createElement('a');
    go.href = route('cart', '/cart');
    go.className = 'btn btn--primary shophelten-side-drawer__go-to-cart';
    go.textContent = str('goToCart', 'Gå til kurv');

    const cont = document.createElement('button');
    cont.type = 'button';
    cont.className = 'btn btn--secondary shophelten-side-drawer__continue';
    cont.setAttribute('data-side-drawer-close', '');
    cont.textContent = str('continueShopping', 'Fortsæt med at handle');

    row.appendChild(go);
    row.appendChild(cont);
    return row;
  }

  function buildLookSection(title, cards, seen) {
    const fresh = cards.filter((card) => {
      const handle = handleFromCard(card);
      if (!handle || seen[handle]) return false;
      seen[handle] = true;
      return true;
    });
    if (!fresh.length) return null;

    const frag = document.createDocumentFragment();
    const label = document.createElement('p');
    label.className = 'shophelten-side-drawer__section-label';
    label.textContent = title || '';
    frag.appendChild(label);

    const holder = document.createElement('div');
    holder.className = 'stl-look';
    fresh.forEach((card) => holder.appendChild(card));
    frag.appendChild(holder);
    return frag;
  }

  function cardsFromNode(node) {
    return node ? Array.from(node.querySelectorAll('.card')) : [];
  }

  function openShopTheLook(trigger) {
    const productId = trigger.dataset.stlProductId;
    if (!productId) return;
    const token = ++notificationToken;

    drawer.classList.add('shophelten-side-drawer--stl');
    setTitle(str('shopTheLook', 'Complete with'));

    const header = document.createElement('div');
    header.className = 'stl-source';
    if (trigger.dataset.stlImage) {
      const headerImg = document.createElement('img');
      headerImg.src = trigger.dataset.stlImage;
      headerImg.className = 'stl-source__image';
      headerImg.alt = '';
      header.appendChild(headerImg);
    }
    if (trigger.dataset.stlTitle) {
      const titleP = document.createElement('p');
      titleP.className = 'stl-source__title';
      titleP.textContent = trigger.dataset.stlTitle;
      header.appendChild(titleP);
    }

    const wrap = document.createElement('div');
    wrap.innerHTML = '<div class="shophelten-side-drawer__empty">…</div>';
    bodyEl.replaceChildren(header, wrap);
    setFooter([]);
    bodyEl.scrollTop = 0;
    openDrawer(trigger);

    const handle = trigger.dataset.stlHandle;
    refreshCartHandles().then(() => Promise.all([
      fetchUpsellList(productId, 'complementary'),
      fetchUpsellList(productId, 'related'),
      fetchLinkedCards(handle)
    ])).then(([compNode, relNode, linkedCards]) => {
      if (token !== notificationToken) return;
      const seen = {};
      wrap.replaceChildren();
      const compSection = buildLookSection(
        str('complementaryTitle', 'Recommended accessories'),
        linkedCards.concat(cardsFromNode(compNode)),
        seen
      );
      if (compSection) wrap.appendChild(compSection);
      const relSection = buildLookSection(str('fallbackTitle', 'You may also like'), cardsFromNode(relNode), seen);
      if (relSection) wrap.appendChild(relSection);
      if (!wrap.children.length) {
        wrap.innerHTML = `<p class="shophelten-side-drawer__empty">${str('moreForYou', '')}</p>`;
      }
    }).catch(() => {
      if (token !== notificationToken) return;
      wrap.replaceChildren();
    });
  }

  function buildConfirm(line, immediateImageSrc = '') {
    const wrap = document.createElement('div');
    wrap.className = 'shophelten-side-drawer__confirm';
    const imgUrl = normalizeImageSrc(immediateImageSrc || line?.featured_image?.url || line?.image || '');

    if (imgUrl) {
      const media = document.createElement('div');
      media.className = 'shophelten-side-drawer__confirm-media';
      const image = document.createElement('img');
      image.className = 'shophelten-side-drawer__confirm-img';
      image.src = imgUrl;
      image.alt = '';
      media.appendChild(image);
      wrap.appendChild(media);
    }

    const meta = document.createElement('div');
    meta.className = 'shophelten-side-drawer__confirm-meta';
    const name = document.createElement('b');
    name.className = 'shophelten-side-drawer__confirm-name';
    name.textContent = line?.product_title || line?.title || '';
    meta.appendChild(name);

    const detail = document.createElement('span');
    detail.className = 'shophelten-side-drawer__confirm-detail';
    const sizeValue = lineSize(line);
    const money = formatMoney(line?.final_price != null ? line.final_price : line?.price);
    detail.textContent = sizeValue ? `${sizeValue} · ${money}` : money;
    meta.appendChild(detail);

    const ok = document.createElement('span');
    ok.className = 'shophelten-side-drawer__confirm-ok';
    ok.textContent = `✓ ${str('addedConfirmation', 'was added to your cart')}`;
    meta.appendChild(ok);
    wrap.appendChild(meta);
    return wrap;
  }

  function appendDrawerRecs(productId, handle, token) {
    if (!productId) return;
    Promise.all([
      fetchUpsellList(productId, 'complementary'),
      fetchUpsellList(productId, 'related'),
      fetchLinkedCards(handle)
    ]).then(([compNode, relNode, linkedCards]) => {
      if (token !== notificationToken) return;
      const seen = {};
      const compSection = buildLookSection(
        str('complementaryTitle', 'Recommended accessories'),
        linkedCards.concat(cardsFromNode(compNode)),
        seen
      );
      if (compSection) bodyEl.appendChild(compSection);
      const relSection = buildLookSection(str('fallbackTitle', 'You may also like'), cardsFromNode(relNode), seen);
      if (relSection) bodyEl.appendChild(relSection);
    }).catch(() => {});
  }

  function openNotification(data, opener, immediateImageSrc = '') {
    const line = normalizeCartAddResponse(data);
    if (!line || isFeeProductLine(line)) return false;
    const token = ++notificationToken;

    drawer.classList.remove('shophelten-side-drawer--stl');
    setTitle(str('addedToCart', 'Tilføjet til kurven'));
    bodyEl.replaceChildren(buildConfirm(line, immediateImageSrc), notificationActions());
    setFooter([]);
    bodyEl.scrollTop = 0;
    openDrawer(opener);

    const productId = line.product_id || line.product?.id;
    const handle = line.handle || (line.url ? line.url.split('?')[0].split('/').pop() : '');
    refreshCartHandles().then(() => appendDrawerRecs(productId, handle, token));
    return true;
  }

  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-size-sheet-close]')) {
      closeSizeSheet();
      return;
    }

    const sheetSize = event.target.closest('[data-size-sheet-size]');
    if (sheetSize && !sheetSize.disabled) {
      sheetList.querySelectorAll('.size-sheet__size').forEach((size) => size.classList.remove('is-selected'));
      sheetSize.classList.add('is-selected');
      sheetVariant = sheetSize.dataset.variantId;
      sheetAddBtn.disabled = false;
      return;
    }

    if (event.target.closest('[data-size-sheet-add]')) {
      addFromSheet();
      return;
    }

    if (event.target.closest('[data-side-drawer-close]')) {
      closeDrawer();
      return;
    }

    const size = event.target.closest('[data-stl-size]');
    if (size && !size.disabled) {
      const group = size.closest('[data-stl-sizes]');
      group.querySelectorAll('[data-stl-size]').forEach((button) => button.classList.remove('is-selected'));
      size.classList.add('is-selected');
      group.classList.remove('is-missing-size');
      return;
    }

    const addButton = event.target.closest('[data-stl-add]');
    if (addButton && !addButton.classList.contains('is-added')) {
      const card = addButton.closest('[data-stl-product]');
      if (addButton.closest('.stl-look--upsell') && card && !isSingleVariant(card)) {
        openSizeSheet(card);
      } else {
        addOne(addButton);
      }
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-stl-trigger]');
    if (!trigger) return;
    event.preventDefault();
    openShopTheLook(trigger);
  });

  document.addEventListener('click', (event) => {
    rememberCartAddButton(cartAddButtonFromTarget(event.target));
  }, true);

  document.addEventListener('pointerdown', (event) => {
    rememberCartAddButton(cartAddButtonFromTarget(event.target));
  }, true);

  document.addEventListener('submit', (event) => {
    if (!isCartAddForm(event.target)) return;
    const button = event.submitter || event.target.querySelector('[name="add"], [data-add-to-cart], button[type="submit"], input[type="submit"]');
    rememberCartAddButton(button);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (sizeSheet?.classList.contains('is-open')) {
      closeSizeSheet();
      return;
    }
    if (drawer.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('error', (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement)) return;
    if (!image.matches('.stl-product__image-hover, .shophelten-side-drawer__confirm-img--hover')) return;
    removeBrokenHoverImage(image);
  }, true);

  bodyEl.addEventListener('submit', (event) => {
    const form = event.target.closest('form.js-product-form');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const btn = form.querySelector('button[name="add"]');
    if (btn && btn.classList.contains('is-added')) return;
    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;
    if (btn) btn.classList.add('is-loading');
    addItems([{ id: variantId, quantity: 1 }])
      .then(() => {
        markAdded(btn);
        refreshCartUi();
      })
      .catch((error) => {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-disabled');
        }
        console.error(error);
      });
  }, true);

  let lookCache = {};
  function fillTriggerThumbs() {
    document.querySelectorAll('[data-stl-trigger]').forEach((trigger) => {
      const thumbsEl = trigger.querySelector('[data-stl-thumbs]');
      if (!thumbsEl || thumbsEl.dataset.loaded) return;
      const productId = trigger.dataset.stlProductId;
      const handle = trigger.dataset.stlHandle;
      if (!productId) return;
      thumbsEl.dataset.loaded = '1';
      const request = lookCache[productId] || (lookCache[productId] = Promise.all([
        fetchUpsellList(productId, 'complementary'),
        fetchLinkedCards(handle)
      ]));
      request.then(([compNode, linkedCards]) => {
        const cards = linkedCards.concat(cardsFromNode(compNode));
        if (!cards.length) {
          trigger.classList.add('hide');
          return;
        }
        const seen = {};
        let added = 0;
        cards.forEach((card) => {
          if (added >= 3) return;
          const handle = handleFromCard(card);
          if (handle && seen[handle]) return;
          if (handle) seen[handle] = true;
          const img = card.querySelector('.card__media img');
          const src = img && (img.getAttribute('src') || img.currentSrc);
          if (!src) return;
          const thumb = document.createElement('img');
          thumb.className = 'cart-item-stl__thumb';
          thumb.src = src;
          thumb.alt = '';
          thumb.loading = 'lazy';
          thumbsEl.appendChild(thumb);
          added += 1;
        });
        if (!added) trigger.classList.add('hide');
        else trigger.classList.remove('hide');
      }).catch(() => trigger.classList.add('hide'));
    });
  }

  let lookTimer = null;
  function refreshLook() {
    clearTimeout(lookTimer);
    lookTimer = setTimeout(() => {
      lookCache = {};
      document.querySelectorAll('[data-stl-thumbs]').forEach((el) => {
        el.replaceChildren();
        delete el.dataset.loaded;
      });
      document.querySelectorAll('[data-stl-trigger]').forEach((trigger) => trigger.classList.add('hide'));
      refreshCartHandles().then(fillTriggerThumbs);
    }, 80);
  }

  refreshLook();
  document.addEventListener('on:line-item:change', refreshLook);
  document.addEventListener('on:cart:add', refreshLook);
  document.addEventListener('cart:updated', refreshLook);

  const cartItemsEl = document.getElementById('cart-items');
  if (cartItemsEl) {
    new MutationObserver(refreshLook).observe(cartItemsEl, { childList: true });
  }

  (function initCartRecs() {
    const container = document.querySelector('[data-cart-recommendations]');
    if (!container) return;
    const root = window.Shopify?.routes?.root || '/';
    const localTemplate = document.getElementById('CartRecsTemplate');

    function fetchRecs(productId, intent) {
      const params = new URLSearchParams({
        section_id: 'cart-recommendations',
        product_id: String(productId),
        limit: '10',
        intent
      });
      return fetch(`${root}recommendations/products?${params}`, { credentials: 'same-origin' })
        .then((response) => response.text())
        .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-recs'));
    }

    function wrapCard(card) {
      if (!card) return null;
      if (card.classList.contains('cart-recs__card')) return card;
      const wrapper = document.createElement('div');
      wrapper.className = 'cart-recs__card';
      wrapper.appendChild(card);
      return wrapper;
    }

    function recsTemplate(apiNode) {
      if (localTemplate?.content?.firstElementChild) {
        return localTemplate.content.firstElementChild.cloneNode(true);
      }
      return apiNode ? apiNode.cloneNode(true) : null;
    }

    function wireArrows(scope) {
      const track = scope.querySelector('[data-recs-track]');
      const prev = scope.querySelector('[data-recs-prev]');
      const next = scope.querySelector('[data-recs-next]');
      if (!track) return;
      const step = () => {
        const card = track.querySelector('.cart-recs__card');
        return card ? card.getBoundingClientRect().width + 16 : 200;
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    }

    function buildGroup(template, title, cards) {
      if (!template || !cards.length) return null;
      const group = template.cloneNode(true);
      const heading = group.querySelector('.cart-recs__title');
      if (heading) heading.textContent = title || '';
      const track = group.querySelector('[data-recs-track]');
      if (!track) return null;
      track.replaceChildren();
      cards.forEach((card) => track.appendChild(card));
      return group;
    }

    function load() {
      fetch(cartJsonUrl(), { credentials: 'same-origin', cache: 'no-store' })
        .then((response) => response.json())
        .then((cart) => {
          setCartHandles(cart);
          if (!cart.items?.length) {
            container.replaceChildren();
            return null;
          }
          const ids = [];
          const handles = [];
          cart.items.forEach((item) => {
            if (ids.indexOf(item.product_id) === -1) ids.push(item.product_id);
            if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
          });
          const sliceIds = ids.slice(0, 5);
          const sliceHandles = handles.slice(0, 5);
          return Promise.all([
            Promise.all(sliceHandles.map((handle) => fetchLinkedCards(handle).catch(() => []))),
            Promise.all(sliceIds.map((id) => Promise.all([
              fetchRecs(id, 'complementary'),
              fetchRecs(id, 'related')
            ]).then(([compNode, relNode]) => ({ compNode, relNode })).catch(() => null)))
          ]);
        })
        .then((payload) => {
          if (!payload) return;
          const linkedLists = payload[0] || [];
          const results = (payload[1] || []).filter(Boolean);
          let apiTemplate = null;
          let compCards = [];
          let relCards = [];
          results.forEach((res) => {
            if (res.compNode) {
              if (!apiTemplate) apiTemplate = res.compNode;
              compCards = compCards.concat(Array.from(res.compNode.querySelectorAll('.cart-recs__card')));
            }
            if (res.relNode) {
              if (!apiTemplate) apiTemplate = res.relNode;
              relCards = relCards.concat(Array.from(res.relNode.querySelectorAll('.cart-recs__card')));
            }
          });

          const seen = {};
          const collected = [];
          const take = (card) => {
            const handle = handleFromCard(card);
            if (!handle || cartHandles[handle] || seen[handle]) return;
            seen[handle] = true;
            const wrapped = wrapCard(card);
            if (wrapped) collected.push(wrapped);
          };

          linkedLists.flat().forEach(take);
          compCards.forEach(take);
          relCards.forEach(take);

          const template = recsTemplate(apiTemplate);
          const group = buildGroup(template, str('moreForYou', 'Du vil måske også kunne li’'), collected.slice(0, 10));
          if (!group) {
            container.replaceChildren();
            return;
          }
          container.replaceChildren(group);
          wireArrows(group);
        })
        .catch(() => container.replaceChildren());
    }

    load();
    document.addEventListener('on:line-item:change', load);
    document.addEventListener('on:cart:add', load);
    document.addEventListener('cart:updated', load);
  })();

  window.ShopHeltenCartUpsell = {
    openNotification,
    refreshCartUi,
    suppressNextCartAdd: false
  };
  window.openCartNotification = openNotification;
  installCartAddHook();
})();
